import {checkIfBotHasBonusDice} from "./checkIfBotHasBonusDice";
import {checkIfAnyOpponentIsBot} from "./checkIfAnyOpponentIsBot";
import {getPlayerBonusValues} from "../gameState/getPlayerBonusValues";

// Прибавка к выпавшему значению d6 бота (поле d6RollBonus уровня бонуса, см.
// configs/playerBonus); результат не выше 6 (см. getD6Roll). Сейчас ни один
// уровень прибавки не задает — механизм остался от рубиновых ботов и годится
// для будущих уровней. Действует там же, где пол, и так же снимается в бою с
// ботами (см. getBotD6MinRoll).
export const getBotD6RollBonus = (player, opponents) => (
  checkIfBotHasBonusDice(player) && !checkIfAnyOpponentIsBot(player, opponents)
    ? getPlayerBonusValues(player).d6RollBonus || 0
    : 0
);
